export type ValueWithImage = {
  value: string;
  image: { src: string; width: number; height: number };
};

export type ReviewTab = {
  name: string;
  step: number;
  current: boolean;
  touched: boolean;
};

export const FitOptions = [
  {
    value: "too_small",
    image: {
      src: "/images/product-page/review-form/too-small.png",
      width: 40,
      height: 40,
    },
  },
  {
    value: "true_to_size",
    image: {
      src: "/images/product-page/review-form/true-to-size.png",
      width: 40,
      height: 40,
    },
  },
  {
    value: "too_big",
    image: {
      src: "/images/product-page/review-form/too-big.png",
      width: 40,
      height: 40,
    },
  },
];

export const days = [
  {
    value: "light",
    image: "/images/product-page/review-form/light-period-day.png",
  },
  {
    value: "moderate",
    image: "/images/product-page/review-form/moderate-period-day.png",
  },
  {
    value: "heavy",
    image: "/images/product-page/review-form/heavy-period-day.png",
  },
];

export const periodManagementOptionsData = [
  {
    value: "shemsi",
    image: {
      src: "/images/product-page/review-form/shemsi-underwear.png",
      width: 64,
      height: 48,
    },
  },
  {
    value: "tampons",
    image: {
      src: "/images/product-page/review-form/tampon.png",
      width: 16,
      height: 56,
    },
  },
  {
    value: "liners",
    image: {
      src: "/images/product-page/review-form/liner.png",
      width: 24,
      height: 56,
    },
  },
  {
    value: "disposable_pads",
    image: {
      src: "/images/product-page/review-form/disposable-pad.png",
      width: 32,
      height: 56,
    },
  },
  {
    value: "reusable_pads",
    image: {
      src: "/images/product-page/review-form/reusable-pad.png",
      width: 24,
      height: 56,
    },
  },
  {
    value: "cups",
    image: {
      src: "/images/product-page/review-form/cup.png",
      width: 32,
      height: 40,
    },
  },
];

export const pantsSizes = [
  { label: "32", value: "32" },
  { label: "34", value: "34" },
  { label: "36", value: "36" },
  { label: "38", value: "38" },
  { label: "40", value: "40" },
  { label: "42", value: "42" },
  { label: "44", value: "44" },
  { label: "46", value: "46" },
  { label: "48", value: "48" },
  { label: "50", value: "50" },
];

export const timingsReviewerIsShemsiUser = [
  "less_than_3_months",
  "3_to_6_months",
  "6_months_to_1_year",
  "more_than_a_year",
];

export const reviewTabsData = [
  { name: "rating", step: 1, current: true, touched: false },
  { name: "fit", step: 2, current: false, touched: false },
  { name: "worn_on", step: 3, current: false, touched: false },
  { name: "review", step: 4, current: false, touched: false },
  { name: "about_you", step: 5, current: false, touched: false },
  { name: "products", step: 6, current: false, touched: false },
  { name: "shemsi_user", step: 7, current: false, touched: false },
  { name: "almost_done", step: 8, current: false, touched: false },
];

export const products = [
  {
    label: "Ipanema",
    value: "ipanema",
    icon: "/images/product-page/review-form/ipanema-icon.png",
  },
  {
    label: "Alexandria",
    value: "alexandria",
    icon: "/images/product-page/review-form/alexandria-icon.png",
  },
  {
    label: "Havana",
    value: "havana",
    icon: "/images/product-page/review-form/havana-icon.png",
  },
  {
    label: "Bahia",
    value: "bahia",
    icon: "/images/product-page/review-form/bahia-icon.png",
  },
];
